import { ICorporatePolicy } from "@/core/interfaces/corporatePolicy.interface";
import { GetterTree } from "vuex";
import {
  ICorporatePolicyState,
  IPolicyBuilderConfig,
  PolicyFormNode,
} from "../types";
import { StoreState } from "@/store/type";
import { PolicyBuilderMapper } from "../mappers/policyBuilder.mapper";

const getters: GetterTree<ICorporatePolicyState, StoreState> = {
  policyBuilderConfig: (state): IPolicyBuilderConfig | null =>
    state.policyBuilderConfig,
  isFetchingPolicyBuilderConfig: (state): boolean =>
    state.isFetchingPolicyBuilderConfig,
  policyFormNodes: (state): PolicyFormNode[] | null =>
    PolicyBuilderMapper.mapToFormNodes(state.policyBuilderConfig),
  corporatePolicies: (state): ICorporatePolicy[] => state.corporatePolicies,
  isFetchingCorporatePolicies: (state): boolean => state.isFetchingCorporatePolicies,
  selectedCorporatePolicy: (state): ICorporatePolicy | null =>
    state.selectedCorporatePolicy,
  isFetchingCorporatePolicy: (state): boolean => state.isFetchingCorporatePolicy,
  corporatePolicyActionLoading: (state): boolean =>
    state.corporatePolicyActionLoading,
};

export default getters;
